export default __webpack_public_path__ + "static/media/header-logout.8e575f95.svg";